import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { successToast } from "../../Utils/utils";
import { loadStripe } from "../Subscriptions/goToStripe";


export function submitRegistrationFormAndBuy(firstName:string, lastName:string, email:string, password:string, product, newsletter, btn){

    const url = '/register/buy'
    const success = function (data){
        successToast("Dein Account wurde erfolgreich erstellt und du wirst jetzt umgeleitet", "Erfolg");
        setTimeout(function(){
            window.location.href = data.checkout_url
        }, 3000);
    }

    const data = {
              'firstName': firstName,
              'lastName': lastName,
              'email': email,
              'password': password,
              'product': product,
              'newsletter': newsletter,
          }

    return ajaxRequest(url, success, data, btn)

}